export default "__VITE_ASSET__fd651700__"